export default "__VITE_ASSET__BwivwoEh__"